export default __webpack_public_path__ + "static/epica-lite-scheda-tecnica-8dd528f7cbffbce5ab4bfdb9d0e0251c.pdf";